import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { useToast } from '../hooks/useToast'

const SolutionFinderContext = createContext(undefined)

export default function SolutionFinderProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const { showToast } = useToast()

  const openFinder = useCallback(() => {
    if (typeof window !== 'undefined') {
      const isMobileViewport = window.matchMedia('(max-width: 1023px)').matches

      if (isMobileViewport) {
        showToast({
          title: 'Nur auf Desktop verfügbar',
          description: 'Für den Lösungsfinder nutze bitte die Desktop-Version unserer Website.',
          variant: 'info',
        })
        return
      }
    }

    setIsOpen(true)
  }, [showToast])

  const closeFinder = useCallback(() => {
    setIsOpen(false)
  }, [])

  const value = useMemo(
    () => ({
      isOpen,
      openFinder,
      closeFinder,
    }),
    [isOpen, openFinder, closeFinder],
  )

  return <SolutionFinderContext.Provider value={value}>{children}</SolutionFinderContext.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSolutionFinder() {
  const context = useContext(SolutionFinderContext)

  if (!context) {
    throw new Error('useSolutionFinder must be used within a SolutionFinderProvider')
  }

  return context
}
